// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-desk {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  z-index: 10;
  background-color: #fff;
}
.footer-desk .reds-cont {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 5px solid #259bbc;
  border-top: 8px solid #eeabb2;
  padding: 1em 0em;
}
.footer-desk .reds-cont .cont-rs {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.5em;
}
.footer-desk .reds-cont .cont-rs .redin {
  width: 2.5em;
  height: 2.5em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  text-decoration: none;
  transition: 0.7s all ease-in-out;
}
.footer-desk .reds-cont .cont-rs .redin i {
  font-size: 1.1em;
  transition: 0.7s all ease-in-out;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(1) {
  box-shadow: rgba(0, 165, 200, 0.56) 0px 0px 12px;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(1) i {
  color: rgb(130, 192, 205);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(1):hover {
  background-color: rgb(0, 165, 200);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(1):hover i {
  color: #fff;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(2) {
  box-shadow: rgba(101, 191, 205, 0.56) 0px 0px 12px;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(2) i {
  color: rgb(101, 191, 205);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(2):hover {
  background-color: rgb(101, 191, 205);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(2):hover i {
  color: #fff;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(3) {
  box-shadow: rgba(140, 205, 205, 0.56) 0px 0px 12px;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(3) i {
  color: rgb(140, 205, 205);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(3):hover {
  background-color: rgb(140, 205, 205);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(3):hover i {
  color: #fff;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(4) {
  box-shadow: rgba(115, 183, 224, 0.56) 0px 0px 12px;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(4) i {
  color: rgb(115, 183, 224);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(4):hover {
  background-color: rgb(115, 183, 224);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(4):hover i {
  color: #fff;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(5) {
  box-shadow: rgba(243, 172, 177, 0.56) 0px 0px 12px;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(5) i {
  color: rgb(243, 172, 177);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(5):hover {
  background-color: rgb(243, 172, 177);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(5):hover i {
  color: #fff;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(6) {
  box-shadow: rgba(243, 165, 141, 0.56) 0px 0px 12px;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(6) i {
  color: rgb(243, 165, 141);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(6):hover {
  background-color: rgb(243, 165, 141);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(6):hover i {
  color: #fff;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(7) {
  box-shadow: rgba(182, 206, 220, 0.56) 0px 0px 12px;
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(7) i {
  color: rgb(182, 206, 220);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(7):hover {
  background-color: rgb(182, 206, 220);
}
.footer-desk .reds-cont .cont-rs .redin:nth-child(7):hover i {
  color: #fff;
}
.footer-desk .rest-cont {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 2em 0em;
  gap: 1.5em;
}
.footer-desk .rest-cont .warn {
  color: #000;
  font-size: 0.9em;
}
.footer-desk .rest-cont .col-cont {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 1em;
  padding: 0em 6em;
}
.footer-desk .rest-cont .col-cont .colt {
  width: 33.33%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 0.3em;
}
.footer-desk .rest-cont .col-cont .colt .titl {
  color: #000;
  font-size: 0.9em;
}
.footer-desk .rest-cont .col-cont .colt .linka {
  color: #666;
  font-size: 0.8em;
  text-decoration: none;
  transition: 0.3s all ease-in-out;
}
.footer-desk .rest-cont .col-cont .colt .linka:hover {
  color: #000;
  padding-left: 0.4em;
}`, "",{"version":3,"sources":["webpack://./src/app/components/desk-footer/desk-footer.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;EACA,6BAAA;EACA,gBAAA;AACN;AACM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AACR;AACQ;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gCAAA;AACV;AACU;EACE,gBAAA;EACA,gCAAA;AACZ;AAGQ;EACE,gDAAA;AADV;AAGU;EACE,yBAAA;AADZ;AAKQ;EACE,kCAAA;AAHV;AAKU;EACE,WAAA;AAHZ;AAOQ;EACE,kDAAA;AALV;AAOU;EACE,yBAAA;AALZ;AASQ;EACE,oCAAA;AAPV;AASU;EACE,WAAA;AAPZ;AAWQ;EACE,kDAAA;AATV;AAWU;EACE,yBAAA;AATZ;AAaQ;EACE,oCAAA;AAXV;AAaU;EACE,WAAA;AAXZ;AAeQ;EACE,kDAAA;AAbV;AAeU;EACE,yBAAA;AAbZ;AAiBQ;EACE,oCAAA;AAfV;AAiBU;EACE,WAAA;AAfZ;AAmBQ;EACE,kDAAA;AAjBV;AAmBU;EACE,yBAAA;AAjBZ;AAqBQ;EACE,oCAAA;AAnBV;AAqBU;EACE,WAAA;AAnBZ;AAuBQ;EACE,kDAAA;AArBV;AAuBU;EACE,yBAAA;AArBZ;AAyBQ;EACE,oCAAA;AAvBV;AAyBU;EACE,WAAA;AAvBZ;AA2BQ;EACE,kDAAA;AAzBV;AA2BU;EACE,yBAAA;AAzBZ;AA6BQ;EACE,oCAAA;AA3BV;AA6BU;EACE,WAAA;AA3BZ;AAiCI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;AA/BN;AAiCM;EACE,WAAA;EACA,gBAAA;AA/BR;AAkCM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAhCR;AAkCQ;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;AAhCV;AAkCU;EACE,WAAA;EACA,gBAAA;AAhCZ;AAmCU;EACE,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,gCAAA;AAjCZ;AAoCU;EACE,WAAA;EACA,mBAAA;AAlCZ","sourcesContent":[".footer-desk{\r\n    width: 100%;\r\n    height: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n    position: relative;\r\n    z-index: 10;\r\n    background-color: #fff;\r\n  \r\n    .reds-cont{\r\n      width: 100%;\r\n      height: auto;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      border-bottom: 5px solid #259bbc;\r\n      border-top: 8px solid #eeabb2;\r\n      padding: 1em 0em;\r\n  \r\n      .cont-rs{\r\n        width: auto;\r\n        height: auto;\r\n        display: flex;\r\n        flex-direction: row;\r\n        justify-content: center;\r\n        align-items: center;\r\n        gap: .5em;\r\n  \r\n        .redin{\r\n          width: 2.5em;\r\n          height: 2.5em;\r\n          display: flex;\r\n          flex-direction: row;\r\n          justify-content: center;\r\n          align-items: center;\r\n          border-radius: 50%;\r\n          text-decoration: none;\r\n          transition: .7s all ease-in-out;\r\n  \r\n          i{\r\n            font-size: 1.1em;\r\n            transition: .7s all ease-in-out;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(1){\r\n          box-shadow: rgb(0 165 200 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(130 192 205 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(1):hover{\r\n          background-color: rgb(0 165 200 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(2){\r\n          box-shadow: rgb(101 191 205 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(101 191 205 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(2):hover{\r\n          background-color: rgb(101 191 205 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(3){\r\n          box-shadow: rgb(140 205 205 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(140 205 205 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(3):hover{\r\n          background-color: rgb(140 205 205 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(4){\r\n          box-shadow: rgb(115 183 224 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(115 183 224 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(4):hover{\r\n          background-color: rgb(115 183 224 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(5){\r\n          box-shadow: rgb(243 172 177 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(243 172 177 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(5):hover{\r\n          background-color: rgb(243 172 177 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(6){\r\n          box-shadow: rgb(243 165 141 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(243 165 141 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(6):hover{\r\n          background-color: rgb(243 165 141 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(7){\r\n          box-shadow: rgb(182 206 220 / 56%) 0px 0px 12px;\r\n  \r\n          i{\r\n            color: rgb(182 206 220 / 100%);\r\n          }\r\n        }\r\n  \r\n        .redin:nth-child(7):hover{\r\n          background-color: rgb(182 206 220 / 100%);\r\n  \r\n          i{\r\n            color: #fff;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  \r\n    .rest-cont{\r\n      width: 100%;\r\n      height: auto;\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: flex-start;\r\n      align-items: center;\r\n      padding: 2em 0em;\r\n      gap: 1.5em;\r\n  \r\n      .warn{\r\n        color: #000;\r\n        font-size: .9em;\r\n      }\r\n  \r\n      .col-cont{\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        flex-direction: row;\r\n        justify-content: center;\r\n        align-items: flex-start;\r\n        gap: 1em;\r\n        padding: 0em 6em;\r\n  \r\n        .colt{\r\n          width: 33.33%;\r\n          height: auto;\r\n          display: flex;\r\n          flex-direction: column;\r\n          justify-content: flex-start;\r\n          align-items: center;\r\n          gap: .3em;\r\n  \r\n          .titl{\r\n            color: #000;\r\n            font-size: .9em;\r\n          }\r\n  \r\n          .linka{\r\n            color: #666;\r\n            font-size: .8em;\r\n            text-decoration: none;\r\n            transition: .3s all ease-in-out;\r\n          }\r\n  \r\n          .linka:hover{\r\n            color: #000;\r\n            padding-left: .4em;\r\n          }\r\n        }\r\n      }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
